import collections from './collections/index'
import relations from './relations'
import seeds from './seeds/index'

import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async create ({ commit, dispatch }) {
    try {
      for (let item of collections()) {
        const { data } = await directus.createCollection(item)
        console.log(data)
      }

      for (let item of relations()) {
        const { data } = await directus.createRelation(item)
        console.log(data)
      }

      for (let seed of seeds()) {
        for (let item of seed.data) {
          if (seed.action) item = await seed.action(item)
          const { data } = await directus.createItem(seed.collection, item)
          console.log(data)
        }
      }

      await dispatch('setDefaultAvatar')
      commit('settings/dataInit/setAttr', {
        name: 'done',
        value: true
      }, { root: true })

      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
